<template>
<v-row justify="center">
<v-dialog v-model="dialog_local" max-width="450">
    <v-form ref="ct" action="#" @submit.prevent="beforeCreateForm('edit')" lazy-validation>
        <v-card class="mx-auto" tile>
        <v-card-title class="justify-space-between" style="background-color: #3D348B; color: white; padding-top: 5px; padding-bottom: 5px">
            {{readonly ? 'View' : 'Update'}} Operator {{`ID ${modalInfo.OperatorID}`}}
            <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
            </v-card-title>
        <v-card-text>
        <v-container class="fill-height"
        fluid >
            <v-row>
                <v-col cols="12" md="12">
                    <v-overlay
                        :absolute="true"
                        :opacity="1"
                        :z-index="999"
                        :value="modal_loader"
                        color="#D2D7DF"
                        >
                        <v-progress-circular indeterminate size="100"></v-progress-circular>
                        </v-overlay>
                    <v-autocomplete
                        dense
                        v-model="form[0].selected"
                        :items="form[0].system"
                        :rules="form[0].rule"
                        item-text="name"
                        item-value="SystemID"
                        label="Select System"
                        outlined
                        disabled
                    ></v-autocomplete>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[1].operatorid"
                        :rules="form[1].rule"
                        label="Operator ID"
                        required
                        disabled
                    ></v-text-field>
                     <v-text-field
                        dense
                        outlined
                        v-model="form[2].operatorname"
                        :rules="form[2].rule"
                        label="Operator Name"
                        required
                        :disabled="readonly"
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[5].picname"
                        :rules="form[5].rule"
                        label="PIC Name"
                        required
                        :disabled="readonly"
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[6].contact"
                        :rules="form[6].rule"
                        label="PIC Contact No."
                        required
                        :disabled="readonly"
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[3].createddatetime"
                        label="Created Date"
                        required
                        disabled
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[4].updateddatetime"
                        label="Updated Date"
                        required
                        disabled
                    ></v-text-field>
                    <span class="text-body-2">Status</span>
                    <v-switch
                    color="success"
                    class="col-1 pl-0"
                    v-model="form[7].status"
                    :label="`${form[7].status ? 'Enabled' : 'Disabled'}`"
                    :disabled="readonly"
                    ></v-switch>
                </v-col>
            </v-row>
        </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn v-if="!readonly" tile type="submit" small color="primary"><v-icon left x-small dark>fa fa-save</v-icon>Save</v-btn>
            <v-btn v-if="validateAccess('operator_delete')" tile color="error darken-1" small @click="handleDelete('delete')" class="ml-2">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn tile color="blue darken-1" text @click="$emit('closed', false)">Close</v-btn>
        </v-card-actions>
        </v-card>
    </v-form>
    <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
    <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
    </v-snackbar>
</v-dialog>
</v-row>
</template>
<script>
import alertbox from './Alert';
import {ERR} from '../../assets/js/errhandle.js';
import {rule} from '../../assets/js/checkPerm';

export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master', 'allInfo', 'readonly'],
    
    data()  {
        return {
            dialog_local: false,
            innerModal: false,
            form: [ 
                {system: [], selected: '', rule: [], label: 'System ID' },
                {operatorid: '', rule: [], label: 'Operator ID' },
                {operatorname: '', rule: [], label: 'Operator Name' },
                {createddatetime: '', rule: [], label: 'Created Date' },
                {updateddatetime: '', rule: [], label: 'Updated Date' },
                {picname: '', rule: [], label: 'PIC Name' },
                {contact: '', rule: [], label: 'Mobile' },
                {status: null, rule: [], label: 'Status' },
            ],

            btn_loading: false,

            roles: [],
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                edit_modal: false,
                view_modal: false,
                confirmEdit: false,
                confirmCreate: false,
            },
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            modal_loader: false
        }
    },

    components: {alertbox},

    watch: {
        dialog: {
        handler: async function(value) {
            await this.modalHandler();
            if(value == true){
                this.modal_loader = true;
                await this.handleValue();
                this.modal_loader = false;
                this.btn_loading = false;
            }
        },
        },

        dialog_local: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    created(){
        this.$watch(() => this.form[0].system, this.onRuleChange);
        this.$watch(() => this.form[1].operatorid, this.onRuleChange);
        this.$watch(() => this.form[1].operatorname, this.onRuleChange);
    },

    methods: {
        async onRuleChange(after, before) {
            this.form[0].rule = [];
            this.form[1].rule = [];
            this.form[2].rule = [];
        },

        async getAllSystem(){
            let list = [];
            try{
                let response = await this.$store.dispatch("getAllSystem2", {search: ''});
                let dt = response.data.record;
                this.form[0].system.push({name: "Select System", SystemID: ""});
                if (response.data.code == "AP000"){
                    for(var i=0; i<dt.length; i++){
                        dt[i].name = `${dt[i].SystemID} - ${dt[i].SystemName}`;

                        this.form[0].system.push(dt[i]);
                    }
                }

                list = dt;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async beforeCreateForm(flag){
            this.form[0].rule = [
                v => !!v || 'System is required',
            ];

            this.form[1].rule = [
                v => !!v || 'Operator ID is required',
            ];

            this.form[2].rule = [
                v => !!v || 'Operator Name is required',
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.ct.validate()) {
                    self.innerModal = true;
                    self.ma.modalInfo = {id: 1, name: 2};
                    self.ma.modal_action_type = flag;
                }
            });
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        modalHandler(){
            this.dialog_local = !this.dialog_local;
        },

        modalCloseHandler(){
            if (this.dialog_local == false){
                this.$emit('closed', false);
            }
        },

        async handleValue(){
            await this.getAllSystem();
            this.form[0].selected = this.modalInfo.SystemID;
            this.form[1].operatorid = this.modalInfo.OperatorID;
            this.form[2].operatorname = this.modalInfo.OperatorName;
            this.form[3].createddatetime = this.modalInfo.CreatedDateTime;
            this.form[4].updateddatetime = this.modalInfo.UpdatedDateTime;
            this.form[5].picname = this.modalInfo.picname;
            this.form[6].contact = this.modalInfo.contact;
            this.form[7].status = this.modalInfo.Status;
        },

        handleDelete(value){
            this.innerModal = true;
            this.ma.modal_action_type = value;
        },

        //set the action to be sent to watcher to execute the create/edit function
        async onConfirm(value){
                if (this.ma.modal_action_type == 'edit'){
                    this.form.flag = 'update';
                    this.$emit('confirm', this.form);
                }

                if (this.ma.modal_action_type == 'delete'){
                    this.form.flag = 'delete';
                    this.$emit('delete');
                }

                this.innerModal = false;
        },

        onClosed(value){
            if (value == false){
                this.innerModal = value;
            }
        },
    }
}
</script>